var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M12.667 1.44531C6.72993 1.44531 1.91699 6.25825 1.91699 12.1953C1.91699 18.1324 6.72993 22.9453 12.667 22.9453C18.6041 22.9453 23.417 18.1324 23.417 12.1953C23.417 6.25825 18.6041 1.44531 12.667 1.44531Z",
    fill: "#456EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6973 9.16498C17.9902 9.45787 17.9902 9.93275 17.6973 10.2256L12.1973 15.7256C12.0567 15.8663 11.8659 15.9453 11.667 15.9453C11.4681 15.9453 11.2773 15.8663 11.1367 15.7256L8.63666 13.2256C8.34377 12.9327 8.34377 12.4579 8.63666 12.165C8.92955 11.8721 9.40443 11.8721 9.69732 12.165L11.667 14.1346L16.6367 9.16498C16.9296 8.87209 17.4044 8.87209 17.6973 9.16498Z",
    fill: "#456EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectMark);
export default __webpack_public_path__ + "static/media/correct-mark.af5e05a8c28b4a966f29b7cab36e0801.svg";
export { ForwardRef as ReactComponent };